import State from 'interfaces/state/State';

export const isLoading$ = (state: State) => state.uploadTrack.isLoading;
export const isError$ = (state: State) => state.uploadTrack.isError;
export const track$ = (state: State) => state.uploadTrack.track;
export const progress$ = (state: State) => state.uploadTrack.progress;
export const isOpenUploadPopup$ = (state: State) => state.uploadTrack.isOpenUploadPopup;
export const duration$ = (state: State) => state.uploadTrack.duration;
export const file_size$ = (state: State) => state.uploadTrack.file_size;
